import React from 'react';
import { useTranslation } from 'react-i18next';

const AgentQuickActionsWidget = ({ actions, onActionClick }) => {
  const { t } = useTranslation();

  return (
    <div className="mb-6">
      <p className="text-xs uppercase tracking-wider text-neutral-500 mb-3">
        {t('dashboard.quickActions')}
      </p>
      <div className="flex flex-wrap gap-2">
        {actions.map((action) => {
          const Icon = action.icon;
          return (
            <button
              key={action.name}
              type="button"
              disabled={action.disabled}
              onClick={() => onActionClick(action)}
              className={`inline-flex items-center gap-2 rounded-lg border px-3 py-2 text-sm transition-colors ${
                action.disabled
                  ? 'border-neutral-200 bg-neutral-50 text-neutral-400 cursor-not-allowed'
                  : 'border-neutral-200 bg-neutral-50 text-neutral-800 hover:border-neutral-300 hover:bg-neutral-100'
              }`}
            >
              {Icon && <Icon className="h-3.5 w-3.5 shrink-0 text-neutral-800" aria-hidden="true" />}
              <span className="font-medium">{action.name}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default AgentQuickActionsWidget;
